import { render } from "./fileManage.vue?vue&type=template&id=b39dc08e&scoped=true"
import script from "./fileManage.vue?vue&type=script&lang=js"
export * from "./fileManage.vue?vue&type=script&lang=js"

import "./fileManage.vue?vue&type=style&index=0&id=b39dc08e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39dc08e"]])

export default __exports__